var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBlackMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 8 23.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2,23.35v-8H0v-7.28c0-.46.18-.9.5-1.21.31-.33.75-.52,1.21-.51h4.58c.46,0,.89.18,1.21.51.32.32.51.76.5,1.21v7.28h-2v8H1.72h.28ZM3.55,4.39c-.58,0-1.14-.22-1.55-.64-.42-.4-.66-.97-.65-1.55,0-.58.22-1.14.64-1.55.4-.42.96-.65,1.55-.65s1.14.22,1.55.64c.42.4.66.97.65,1.55,0,.58-.22,1.14-.64,1.55-.4.42-.97.66-1.55.65h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2,23.35v-8H0v-7.28c0-.46.18-.9.5-1.21.31-.33.75-.52,1.21-.51h4.58c.46,0,.89.18,1.21.51.32.32.51.76.5,1.21v7.28h-2v8H1.72h.28ZM3.55,4.39c-.58,0-1.14-.22-1.55-.64-.42-.4-.66-.97-.65-1.55,0-.58.22-1.14.64-1.55.4-.42.96-.65,1.55-.65s1.14.22,1.55.64c.42.4.66.97.65,1.55,0,.58-.22,1.14-.64,1.55-.4.42-.97.66-1.55.65h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: -1.65,
    width: 8,
    height: 24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlackMan);
export default __webpack_public_path__ + "static/media/ic_black_man.cd07bcc28d06f5fdcabc37eefe379958.svg";
export { ForwardRef as ReactComponent };